<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<h1>Expenses Report</h1>

<p-card styleClass="single-inputs-only mb-2">
    <div class="formgrid grid">
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2" *ngIf="model.selectedCampaign()?.isEntity">
            <label>Child Campaign</label>
            <rc-table-filter [filterModel]="filters.ChildCampaign.filterModel" (modelChange)="filters.ChildCampaign.filterModel = $event" *ngIf="filters.ChildCampaign" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Fund Code</label>
            <rc-table-filter [dependencyId]="'ChildCampaign'" [filterModel]="filters.FundCode.filterModel" (modelChange)="filters.FundCode.filterModel = $event" *ngIf="filters.FundCode" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Expense Type</label>
            <rc-table-filter [filterModel]="filters.ExpenseType.filterModel" (modelChange)="filters.ExpenseType.filterModel = $event" *ngIf="filters.ExpenseType" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Begin Date</label>
            <rc-table-filter [filterModel]="filters.BeginDate.filterModel" (modelChange)="filters.BeginDate.filterModel = $event" *ngIf="filters.BeginDate" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>End Date</label>
            <rc-table-filter [filterModel]="filters.EndDate.filterModel" (modelChange)="filters.EndDate.filterModel = $event" *ngIf="filters.EndDate" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Event Code</label>
            <rc-table-filter [filterModel]="filters.EventCode.filterModel" (modelChange)="filters.EventCode.filterModel = $event" *ngIf="filters.EventCode" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Vendor Name</label>
            <rc-table-filter [filterModel]="filters.VendorName.filterModel" (modelChange)="filters.VendorName.filterModel = $event" *ngIf="filters.VendorName" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Division</label>
            <rc-table-filter [filterModel]="filters.DivisionNumber.filterModel" (modelChange)="filters.DivisionNumber.filterModel = $event" *ngIf="filters.DivisionNumber" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Event Type</label>
            <rc-table-filter [filterModel]="filters.EventTypeID.filterModel" (modelChange)="filters.EventTypeID.filterModel = $event" *ngIf="filters.EventTypeID" [showToFilters]="false" />
        </div>
    </div>
    
    <div class="py-2 flex justify-content-end">
        <rc-generic-button 
                label="Clear All"
                id="button-clear-filters"
                iconImg="clear-filter"
                borderStyle="outline"
                [classes]="['my-1']"
                (click)="resetFilters()"/>
                
            <rc-generic-button 
                label="View Report"
                id="button-search"
                iconImg="search"
                [classes]="['my-1 ml-1']"
                (click)="onSearch()" />
    </div>
</p-card>
<p-card>
    
    <div style="width: 100%; position: relative; min-height: 22rem;">
        <p-table 
            #resultstable 
            selectionMode="multiple"
            scrollHeight="flex" 
            filter="false"
            styleClass="rc-datatable-outlined"
            [rows]="pagingModel.maxResults"
            [(selection)]="displayColumns"
            [columns]="displayColumns" 
            [value]="data"
            [exportHeader]="'customExportHeader'"
            [paginator]="!showLoading && hasResults && data.length > pagingModel.maxResults" 
            [sortField]="pagingModel.sortField" 
            [sortOrder]="pagingModel.sortAsc" 
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            (onPage)="pageChange($event)" 
            [scrollable]="true" 
            [reorderableColumns]="false"
            id="table-data">

            <ng-template pTemplate="caption" style="min-height: 300px"></ng-template>
            <ng-template #defaultTableHeaderTemplate>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        @for (col of displayColumns; track col.columnName ){
                        <th 
                            *ngIf="col.visible"
                            pSortableColumn={{col.columnName}} id="column-{{col.columnName}}"
                            style="vertical-align: top;" 
                            nowrap
                            >
                            <div class="sortable-title">    
                                <div class="column-title" [textContent]="col.displayColumn"></div>
                                <p-sortIcon 
                                    [field]="col.columnName" 
                                    style="cursor: pointer;"
                                    />
                            </div>
                        </th>
                        }
                    </tr>
                    
                    
                </ng-template>
            </ng-template> 

            <!-- [(selection)]="selectedColumns" -->
            <ng-container [ngTemplateOutlet]="defaultTableHeaderTemplate">
            </ng-container>
            
            
            <ng-template pTemplate="body" let-item let-index="rowIndex" #defaultTableBodyTemplate>

                <tr *ngIf="!showLoading && hasResults">
                    <!-- [class]="getIsChecked(item, itemsChecked) ? 'selected' : ''" -->
                    @for (column of displayColumns; track $index ){
                    <td *ngIf="column.visible === true">
                        <span *ngIf="column.columnName !== 'DonorID'" [textContent]="getDisplayValue(item, column)"></span>
                    </td>
                    }
                    
                </tr>

            </ng-template>
                
        </p-table>
            
        <div *ngIf="showLoading || !hasResults" ngClass="medium loader-wrapper">
            <div *ngIf="showLoading">
                <rc-loading-spinner></rc-loading-spinner>
            </div>
            <td *ngIf="!showLoading && !searchPerformed && !hasResults" colSpan={{data.length}} class="text-center no-data-message">
                Please adjust filters and click Search to generate report.
            </td>
            <td *ngIf="!showLoading && searchPerformed && !hasResults" colSpan={{data.length}} class="text-center no-data-message">
                No results available. Please adjust filters and try again.
            </td>
        </div>

        <div class="py-2 flex justify-content-end" *ngIf="hasResults">
            <p-button
                [disabled]="!hasResults"
                label="Export"
                icon="fa-sharp fa-light fa-download"
                id="button-export"
                styleClass="my-1"
                severity="secondary"
                (onClick)="exportToExcel()"
                class="ml-0"></p-button>
        </div>
    </div>

</p-card>
